import ProductsSliderPresenter from "../../products-slider/presenter/products-slider.js";
import ProductCardsPresenter from "../presenter/product-cards.js";

export default class ModalRelatedProductsSlider extends ProductsSliderPresenter {
  constructor(wrapperElement, defaultSliderOptions) {
    super(wrapperElement);

    this._sliderOptions = Object.assign(
        {},
        this._sliderOptions,
        defaultSliderOptions
    );

    this._ProductCardsPresenter = ProductCardsPresenter;
  }
}
